export enum SUBJECT {
  Algebra_I = 1,
  Algebra_II = 2,
  Calculus = 3,
  Geometry = 4,
  Math_I = 5,
  Math_II = 6,
  Math_III = 7,
  Statistics_And_Probability = 8,
  Statistics_And_Probability_AP = 9,
  History_Social_Science = 10,
  Science_CANGSS = 11,
  EngineeringTechnologyApplicationsOfScience = 12,
  Life_Science = 13,
  Physical_Science = 14,
  English = 15,
  Biology = 16,
  Biology_AP = 17,
  Chemistry = 18,
  Chemistry_AP = 19,
  Computer_Science = 20,
  Music = 21,
  English_Language_Development = 22,
  Pre_Algebra = 23,
  Physics = 24,
  Physics_AP = 25,
  Spanish = 26,
  Spanish_AP = 27,
  French = 28,
  French_AP = 29,
  Latin = 30,
  Physical_Education = 31,
  Entrepreneurship = 32,
  CTE_AgricultureAndNaturalResources = 33,
  CTE_ArtsMediaAndEntertainment = 34,
  CTE_BuildingAndConstructionTrades = 35,
  CTE_BusinessAndFinance = 36,
  CTE_EducationChildDevelopmentAndFamilyServices = 37,
  CTE_EnergyEnvironmentAndUtilities = 38,
  CTE_EngineeringAndArchitecture = 39,
  CTE_FashionAndInteriorDesign = 40,
  CTE_HealthScienceAndMedicalTechnology = 41,
  CTE_HospitalityTourismAndRecreation = 42,
  CTE_InformationAndCommunicationTechnologies = 43,
  CTE_ManufacturingAndProductDevelopment = 44,
  CTE_MarketingSalesAndService = 45,
  CTE_PublicServices = 46,
  CTE_Transportation = 47,
  Visual_Arts = 54,
  Theatre = 55,
  Pre_Calculus = 56,
  Environmental_Science = 57,
  Dance = 58,
  Media_Arts = 59,
  Film = 60,
}

// Mapping object for display-friendly names
export const SUBJECT_DISPLAY_NAMES: { [key in SUBJECT]: string } = {
  [SUBJECT.Algebra_I]: 'Algebra I',
  [SUBJECT.Algebra_II]: 'Algebra II',
  [SUBJECT.Calculus]: 'Calculus',
  [SUBJECT.Geometry]: 'Geometry',
  [SUBJECT.Math_I]: 'Math I',
  [SUBJECT.Math_II]: 'Math II',
  [SUBJECT.Math_III]: 'Math III',
  [SUBJECT.Statistics_And_Probability]: 'Statistics And Probability',
  [SUBJECT.Statistics_And_Probability_AP]: 'Statistics And Probability (AP)',
  [SUBJECT.History_Social_Science]: 'History Social Science',
  [SUBJECT.Science_CANGSS]: 'Science (CA NGSS)',
  [SUBJECT.EngineeringTechnologyApplicationsOfScience]: 'Engineering, Technology, and Applications of Science',
  [SUBJECT.Life_Science]: 'Life Science',
  [SUBJECT.Physical_Science]: 'Physical Science',
  [SUBJECT.English]: 'English',
  [SUBJECT.Biology]: 'Biology',
  [SUBJECT.Biology_AP]: 'Biology (AP)',
  [SUBJECT.Chemistry]: 'Chemistry',
  [SUBJECT.Chemistry_AP]: 'Chemistry (AP)',
  [SUBJECT.Computer_Science]: 'Computer Science',
  [SUBJECT.Music]: 'Music',
  [SUBJECT.English_Language_Development]: 'English Language Development',
  [SUBJECT.Pre_Algebra]: 'Pre-Algebra',
  [SUBJECT.Physics]: 'Physics',
  [SUBJECT.Physics_AP]: 'Physics (AP)',
  [SUBJECT.Spanish]: 'Spanish',
  [SUBJECT.Spanish_AP]: 'Spanish (AP)',
  [SUBJECT.French]: 'French',
  [SUBJECT.French_AP]: 'French (AP)',
  [SUBJECT.Latin]: 'Latin',
  [SUBJECT.Physical_Education]: 'Physical Education',
  [SUBJECT.Entrepreneurship]: 'Entrepreneurship',
  [SUBJECT.CTE_AgricultureAndNaturalResources]: 'CTE - Agriculture and Natural Resources',
  [SUBJECT.CTE_ArtsMediaAndEntertainment]: 'CTE - Arts, Media, and Entertainment',
  [SUBJECT.CTE_BuildingAndConstructionTrades]: 'CTE - Building and Construction Trades',
  [SUBJECT.CTE_BusinessAndFinance]: 'CTE - Business and Finance',
  [SUBJECT.CTE_EducationChildDevelopmentAndFamilyServices]: 'CTE - Education, Child Development, and Family Services',
  [SUBJECT.CTE_EnergyEnvironmentAndUtilities]: 'CTE - Energy, Environment, and Utilities',
  [SUBJECT.CTE_EngineeringAndArchitecture]: 'CTE - Engineering and Architecture',
  [SUBJECT.CTE_FashionAndInteriorDesign]: 'CTE - Fashion and Interior Design',
  [SUBJECT.CTE_HealthScienceAndMedicalTechnology]: 'CTE - Health Science and Medical Technology',
  [SUBJECT.CTE_HospitalityTourismAndRecreation]: 'CTE - Hospitality, Tourism, and Recreation',
  [SUBJECT.CTE_InformationAndCommunicationTechnologies]: 'CTE - Information and Communication Technologies',
  [SUBJECT.CTE_ManufacturingAndProductDevelopment]: 'CTE - Manufacturing and Product Development',
  [SUBJECT.CTE_MarketingSalesAndService]: 'CTE - Marketing, Sales, and Service',
  [SUBJECT.CTE_PublicServices]: 'CTE - Public Services',
  [SUBJECT.CTE_Transportation]: 'CTE - Transportation',
  [SUBJECT.Visual_Arts]: 'Visual Arts',
  [SUBJECT.Theatre]: 'Theatre',
  [SUBJECT.Pre_Calculus]: 'Pre-Calculus',
  [SUBJECT.Environmental_Science]: 'Environmental Science',
  [SUBJECT.Dance]: 'Dance',
  [SUBJECT.Media_Arts]: 'Media Arts',
  [SUBJECT.Film]: 'Film',
};

export const GENERAL_SUBJECTS = 'General Subjects';
